// src/components/Pages/TreasureChest/huntLogic.ts
var DEFAULT_HIDE_DISTANCE_M = 2.2;
var DEFAULT_OPEN_RADIUS_M = 1;
var CHEST_YAW_SPREAD_RAD = 25 * Math.PI / 180;
var NEAR_RADIUS_FACTOR = 2;
var STAGE_EXIT_FACTOR = 1.1;
var PROXIMITY_HOLD_MS = 300;
var FALLBACK_GAZE_MS = 2e3;
var LOST_GAZE_MS = 3e3;
var TRACKING_LOST_MS = 8e3;
var CHEST_TAP_CONE_RAD = 0.35;
var GAZE_CONE_RAD = 0.9;
var RATTLE_MS = 600;
var RATTLE_TILT_RAD = 3 * Math.PI / 180;
var MAX_TICK_DELTA_MS = 250;
var resolveHideDistanceM = (authored) => authored ?? DEFAULT_HIDE_DISTANCE_M;
var resolveOpenRadiusM = (authored) => authored ?? DEFAULT_OPEN_RADIUS_M;
var pickYawOffset = (rand = Math.random, spreadRad = CHEST_YAW_SPREAD_RAD) => (rand() * 2 - 1) * spreadRad;
var minChestDistanceM = (openRadiusM) => Math.max(1.2, openRadiusM * 1.5);
var facingYaw = (x, z, towardsX, towardsZ) => Math.atan2(towardsX - x, towardsZ - z);
var proximityStage = (distanceM, openRadiusM, previous = null) => {
  const atEnter = openRadiusM;
  const atLeave = openRadiusM * STAGE_EXIT_FACTOR;
  const nearEnter = openRadiusM * NEAR_RADIUS_FACTOR;
  const nearLeave = nearEnter * STAGE_EXIT_FACTOR;
  if (previous === "atChest") {
    if (distanceM <= atLeave) return "atChest";
    return distanceM < nearLeave ? "near" : "far";
  }
  if (distanceM <= atEnter) return "atChest";
  if (previous === "near") return distanceM < nearLeave ? "near" : "far";
  return distanceM < nearEnter ? "near" : "far";
};
var createGateState = () => ({
  nearMs: 0,
  gazeMs: 0,
  lostMs: 0,
  lastTickMs: null
});
var advanceGate = (state, sample, nowMs) => {
  if (state.lastTickMs === null) return { ...state, lastTickMs: nowMs };
  const rawDelta = nowMs - state.lastTickMs;
  if (rawDelta < 0) return state;
  const dt = Math.min(MAX_TICK_DELTA_MS, rawDelta);
  return {
    nearMs: sample.distanceM <= sample.openRadiusM ? state.nearMs + dt : 0,
    gazeMs: sample.lookingAt ? state.gazeMs + dt : 0,
    lostMs: sample.tracked ? 0 : state.lostMs + dt,
    lastTickMs: nowMs
  };
};
var openRoute = (state, { fallback }) => {
  if (state.nearMs >= PROXIMITY_HOLD_MS) return "proximity";
  if (fallback && state.gazeMs >= FALLBACK_GAZE_MS) return "fallbackGaze";
  if (state.lostMs > TRACKING_LOST_MS && state.gazeMs >= LOST_GAZE_MS) {
    return "lostGaze";
  }
  return null;
};
var rattleTilt = (elapsedMs, reduceMotion = false) => {
  if (reduceMotion || elapsedMs <= 0 || elapsedMs >= RATTLE_MS) return 0;
  const t = elapsedMs / RATTLE_MS;
  return Math.sin(t * Math.PI * 6) * RATTLE_TILT_RAD * (1 - t);
};
var huntStatusLine = ({
  phase,
  stage,
  chestName,
  sweepProgress,
  canOpen,
  lookToOpen = false
}) => {
  if (phase === "rattling") return "It\u2019s locked! Enter the code";
  if (phase === "searching") {
    if (sweepProgress < 0.4) {
      return `Move your phone slowly to search for ${chestName}\u2026`;
    }
    if (sweepProgress < 1) return "Keep looking, the ground looks disturbed\u2026";
    return "Something is glinting nearby\u2026";
  }
  if (canOpen) return `Reach out and open ${chestName}`;
  if (lookToOpen) return `There it is! Keep looking at ${chestName} to open it`;
  if (stage === "near") return "Nearly there\u2026";
  return `There it is! Walk up to ${chestName}`;
};

export {
  TRACKING_LOST_MS,
  CHEST_TAP_CONE_RAD,
  GAZE_CONE_RAD,
  RATTLE_MS,
  resolveHideDistanceM,
  resolveOpenRadiusM,
  pickYawOffset,
  minChestDistanceM,
  facingYaw,
  proximityStage,
  createGateState,
  advanceGate,
  openRoute,
  rattleTilt,
  huntStatusLine
};
//# sourceMappingURL=chunk-WPDYYNOF.mjs.map